<span class="divider__inner"><ng-content></ng-content></span>
